import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import WhatsAppFloat from "./WhatsAppFloat";

export const Footer: React.FC = () => {
  const [email, setEmail] = useState("");
  const location = useLocation();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      console.log("Submitting email:", email);
      setEmail("");
    } catch (error) {
      console.error("Failed to submit email:", error);
    }
  };

  const isActive = (path: string) => location.pathname === path;

  return (
    <>
    <footer className="bg-gray-900 text-white">
      {/* ====== MAIN FOOTER ====== */}
      <div className="py-12 sm:py-16">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
            {/* ====== COMPANY INFO ====== */}
            <div>
              <div className="mb-6">
                <Link to="/" className="block">
                  <img
                    src="/logo-alt.webp"
                    alt="INVICTUS"
                    className="h-20 sm:h-24 object-contain mx-auto lg:mx-0 hover:scale-105 transition-transform duration-500" />
                </Link>
              </div>
              <p className="text-gray-300 leading-relaxed text-center lg:text-left mb-6">
                Criamos soluções de TI fáceis de usar, gerenciar e altamente
                confiáveis.
              </p>

              <div className="flex justify-center lg:justify-start">
                <Link
                  to="/contato"
                  className={`bg-blue-600 text-white font-semibold px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors text-sm sm:text-base ${isActive("/Falar com especialista")
                      ? "ring-2 ring-blue-400"
                      : ""}`}
                >
                  Falar com Especialista
                </Link>
              </div>
            </div>

            {/* ====== SERVICES ====== */}
            <div className="text-center sm:text-left">
              <h4 className="text-lg font-semibold mb-6">Serviços</h4>
              <ul className="space-y-3 text-sm sm:text-base">
                {[
                  
                  { label: "Locação e Outsourcing", path: "/servicos/locacao-outsourcing" },
                  { label: "Terceirização de TI", path: "/servicos/terceirizacao-ti" },
                  
                  { label: "Trabalho Remoto", path: "/servicos/trabalho-remoto" },
                ].map((item, i) => (
                  <li key={i}>
                    <Link
                      to={item.path}
                      className="text-gray-300 hover:text-white transition-colors duration-300"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* ====== SUPPORT ====== */}
            <div className="text-center sm:text-left">
              <h4 className="text-lg font-semibold mb-6">Suporte</h4>
              <ul className="space-y-3 text-sm sm:text-base">
                <li>
                  <Link
                    to="/area-cliente"
                    className="text-gray-300 hover:text-white transition-colors"
                  >
                    Área do Cliente
                  </Link>
                </li>
                <li>
                  <a href="#" className="text-gray-300 hover:text-white transition-colors">
                    FAQ
                  </a>
                </li>
                <li>
                  <Link
                    to="/contato"
                    className="text-gray-300 hover:text-white transition-colors"
                  >
                    Contato
                  </Link>
                </li>
              </ul>
            </div>

            {/* ====== CONTACT ====== */}
            <div className="text-center sm:text-left">
              <h4 className="text-lg font-semibold mb-6">Entrar em Contato</h4>
              <ul className="space-y-4 text-sm">
                <li className="flex items-start justify-center sm:justify-start">
                  <i className="ri-building-line mr-3 mt-1 text-blue-400"></i>
                  <span className="text-gray-300">
                    MATRIZ USA | 8562 Boca Rio Drive, Boca Raton FL 33433
                  </span>
                </li>
                <li className="flex items-start justify-center sm:justify-start">
                  <i className="ri-building-line mr-3 mt-1 text-blue-400"></i>
                  <span className="text-gray-300">
                    BRASIL | Governador Valadares <br />
                    Rua João Pinheiro, 599 - LJ 17 - Centro
                  </span>
                </li>
                <li className="flex items-start justify-center sm:justify-start">
                  <i className="ri-mail-line mr-3 mt-1 text-blue-400"></i>
                  <a href="mailto:comercial@invictustecnologia.com" className="text-gray-300 hover:text-white">comercial@invictustecnologia.com</a>
                </li>
                <li className="flex items-start justify-center sm:justify-start">
                  <i className="ri-phone-line mr-3 mt-1 text-blue-400"></i>
                  <a href="tel:+5531973565180" className="text-gray-300 hover:text-white">(31) 9 7356-5180</a>
                </li>
              </ul>

              {/* ====== SOCIAL MEDIA ====== */}
              <div className="mt-6 flex justify-center sm:justify-start space-x-4">
                <a
                  href="https://www.facebook.com/profile.php?id=100077370175022"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-blue-600 text-white rounded-lg flex items-center justify-center hover:bg-blue-700 transition-colors"
                >
                  <i className="ri-facebook-fill"></i>
                </a>
                <a
                  href="https://www.instagram.com/invictustecnologia/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-pink-600 text-white rounded-lg flex items-center justify-center hover:bg-pink-700 transition-colors"
                >
                  <i className="ri-instagram-fill"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ====== BOTTOM FOOTER ====== */}
      <div className="border-t border-gray-800 py-6 text-center">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
          <p className="text-gray-400 text-sm">
            Copyright © {new Date().getFullYear()} — <span className="text-blue-400">INVICTUS</span> | Todos os direitos reservados
          </p>
          <div className="mt-2">
            <Link to="/politica" className="text-gray-400 hover:text-white text-sm mr-4">Política de Privacidade</Link>
            <Link to="/cookies" className="text-gray-400 hover:text-white text-sm">Política de Cookies</Link>
          </div>
        </div>
      </div>
    </footer>
    <WhatsAppFloat />
    </>
  );
};

export default Footer;
